"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersScreen = UsersScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var confirm_dialog_1 = require("../../components/common/confirm-dialog");
var data_table_1 = require("../../components/common/data-table");
var page_header_1 = require("../../components/common/page-header");
var permission_gate_1 = require("../../components/common/permission-gate");
var search_input_1 = require("../../components/common/search-input");
var status_badge_1 = require("../../components/common/status-badge");
var roles_1 = require("../../features/apis/roles");
var users_1 = require("../../features/apis/users");
var use_error_handler_1 = require("../../hooks/use-error-handler");
var permissions_1 = require("../../interfaces/permissions");
var user_1 = require("../../interfaces/user");
function PlusIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) }));
}
function UsersScreen() {
    var _this = this;
    var _a, _b, _c, _d;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _e = (0, use_error_handler_1.useErrorHandler)(), handleError = _e.handleError, handleSuccess = _e.handleSuccess;
    var _f = (0, react_2.useState)(1), page = _f[0], setPage = _f[1];
    var _g = (0, react_2.useState)(""), search = _g[0], setSearch = _g[1];
    var _h = (0, react_2.useState)(""), roleFilter = _h[0], setRoleFilter = _h[1];
    var _j = (0, react_2.useState)(""), statusFilter = _j[0], setStatusFilter = _j[1];
    var _k = (0, react_1.useDisclosure)(), isDeleteOpen = _k.isOpen, onDeleteOpen = _k.onOpen, onDeleteClose = _k.onClose;
    var _l = (0, react_1.useDisclosure)(), isEnableOpen = _l.isOpen, onEnableOpen = _l.onOpen, onEnableClose = _l.onClose;
    var _m = (0, react_1.useDisclosure)(), isDisableOpen = _m.isOpen, onDisableOpen = _m.onOpen, onDisableClose = _m.onClose;
    var _o = (0, react_2.useState)(null), deletingUser = _o[0], setDeletingUser = _o[1];
    var _p = (0, react_2.useState)(null), enablingUser = _p[0], setEnablingUser = _p[1];
    var _q = (0, react_2.useState)(null), disablingUser = _q[0], setDisablingUser = _q[1];
    var _r = (0, users_1.useGetUsersQuery)({
        page: page,
        limit: 10,
        search: search || undefined,
        role_id: roleFilter || undefined,
        status: statusFilter || undefined,
    }), data = _r.data, isLoading = _r.isLoading, isFetching = _r.isFetching;
    var rolesData = (0, roles_1.useGetRolesQuery)({ page: 1, limit: 100 }).data;
    var _s = (0, users_1.useDeleteUserMutation)(), deleteUser = _s[0], isDeleting = _s[1].isLoading;
    var _t = (0, users_1.useEnableUserMutation)(), enableUser = _t[0], isEnabling = _t[1].isLoading;
    var _u = (0, users_1.useDisableUserMutation)(), disableUser = _u[0], isDisabling = _u[1].isLoading;
    // Extract users data from API response
    // API response structure: { success, message, content: { users: [], pagination: { total_pages } } }
    var users = ((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.users) || [];
    var totalPages = ((_c = (_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.total_pages) || 1;
    var roles = ((_d = rolesData === null || rolesData === void 0 ? void 0 : rolesData.content) === null || _d === void 0 ? void 0 : _d.roles) || [];
    // Filter out any users without _id (required by DataTable)
    var validUsers = users.filter(function (user) { return user && user._id; });
    var columns = [
        {
            key: "name",
            label: "Name",
            render: function (item) { return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-medium text-foreground", children: item.name }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-default-500", children: item.email })] })); },
        },
        {
            key: "role",
            label: "Role",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: typeof item.role_id === "object" && item.role_id ? item.role_id.name : "-" }); },
        },
        {
            key: "cell_phone",
            label: "Phone",
            render: function (item) { return ((0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: typeof item.cell_phone === "object" ? "".concat(item.cell_phone.calling_code, " ").concat(item.cell_phone.number) : item.cell_phone || "-" })); },
        },
        {
            key: "status",
            label: "Status",
            render: function (item) { return (0, jsx_runtime_1.jsx)(status_badge_1.StatusBadge, { status: item.status }); },
        },
        {
            key: "actions",
            label: "Actions",
            align: "end",
            render: function (item) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", onPress: function () { return navigate("/users/".concat(item._id)); }, children: "View" }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.USERS, action: permissions_1.ACTIONS.UPDATE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "primary", onPress: function () { return navigate("/users/".concat(item._id, "/edit")); }, children: "Edit" }) }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.USERS, action: permissions_1.ACTIONS.UPDATE, children: item.status === user_1.EUserStatus.INACTIVE ? ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "success", onPress: function () { return handleEnableClick(item); }, children: "Enable" })) : item.status === user_1.EUserStatus.ACTIVE ? ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "warning", onPress: function () { return handleDisableClick(item); }, children: "Disable" })) : null }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.USERS, action: permissions_1.ACTIONS.DELETE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "danger", onPress: function () { return handleDeleteClick(item); }, children: "Delete" }) })] })); },
        },
    ];
    var handleDeleteClick = function (user) {
        setDeletingUser(user);
        onDeleteOpen();
    };
    var handleEnableClick = function (user) {
        setEnablingUser(user);
        onEnableOpen();
    };
    var handleDisableClick = function (user) {
        setDisablingUser(user);
        onDisableOpen();
    };
    var handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!deletingUser)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteUser(deletingUser._id).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("User deleted successfully");
                    onDeleteClose();
                    setDeletingUser(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    handleError(error_1, { defaultMessage: "Failed to delete user" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleEnable = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!enablingUser)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, enableUser(enablingUser._id).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("User enabled successfully");
                    onEnableClose();
                    setEnablingUser(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    handleError(error_2, { defaultMessage: "Failed to enable user" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDisable = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!disablingUser)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, disableUser(disablingUser._id).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("User disabled successfully");
                    onDisableClose();
                    setDisablingUser(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    handleError(error_3, { defaultMessage: "Failed to disable user" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: "Users", description: "Manage system users", actions: [
                    {
                        label: "Add User",
                        icon: (0, jsx_runtime_1.jsx)(PlusIcon, {}),
                        href: "/users/new",
                    },
                ] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-4", children: [(0, jsx_runtime_1.jsx)(search_input_1.SearchInput, { placeholder: "Search users...", value: search, onChange: setSearch, className: "w-64" }), (0, jsx_runtime_1.jsxs)("select", { value: roleFilter, onChange: function (e) { return setRoleFilter(e.target.value); }, className: "h-8 w-40 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Roles" }), roles.map(function (role) { return ((0, jsx_runtime_1.jsx)("option", { value: role._id, children: role.name }, role._id)); })] }), (0, jsx_runtime_1.jsxs)("select", { value: statusFilter, onChange: function (e) { return setStatusFilter(e.target.value); }, className: "h-8 w-40 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Statuses" }), (0, jsx_runtime_1.jsx)("option", { value: "active", children: "Active" }), (0, jsx_runtime_1.jsx)("option", { value: "inactive", children: "Inactive" }), (0, jsx_runtime_1.jsx)("option", { value: "locked", children: "Locked" })] })] }), (0, jsx_runtime_1.jsx)(data_table_1.DataTable, { columns: columns, data: validUsers, isLoading: isLoading || isFetching, page: page, totalPages: totalPages, onPageChange: setPage, onRowClick: function (item) { return navigate("/users/".concat(item._id)); }, emptyContent: "No users found" }), (0, jsx_runtime_1.jsx)(confirm_dialog_1.ConfirmDialog, { isOpen: isDeleteOpen, onClose: onDeleteClose, onConfirm: handleDelete, title: "Delete User", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to permanently delete ", (0, jsx_runtime_1.jsx)("strong", { children: deletingUser === null || deletingUser === void 0 ? void 0 : deletingUser.name }), "? This action cannot be undone."] }), confirmLabel: "Delete", confirmColor: "danger", isLoading: isDeleting }), (0, jsx_runtime_1.jsx)(confirm_dialog_1.ConfirmDialog, { isOpen: isEnableOpen, onClose: onEnableClose, onConfirm: handleEnable, title: "Enable User", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to enable ", (0, jsx_runtime_1.jsx)("strong", { children: enablingUser === null || enablingUser === void 0 ? void 0 : enablingUser.name }), "? They will be able to log in to the system."] }), confirmLabel: "Enable", confirmColor: "success", isLoading: isEnabling }), (0, jsx_runtime_1.jsx)(confirm_dialog_1.ConfirmDialog, { isOpen: isDisableOpen, onClose: onDisableClose, onConfirm: handleDisable, title: "Disable User", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to disable ", (0, jsx_runtime_1.jsx)("strong", { children: disablingUser === null || disablingUser === void 0 ? void 0 : disablingUser.name }), "? They will no longer be able to log in to the system."] }), confirmLabel: "Disable", confirmColor: "warning", isLoading: isDisabling })] }));
}
